












import {Vue, Component, Watch} from 'vue-property-decorator';
import {Mixins} from 'vue-property-decorator';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
import {ORDER_STATUS} from '@/common';
import GenericDialog from '@/components/Views/UI/GenericDialog.vue';


@Component({
    components: {GenericDialog},
})
export default class CancelOrderDialog extends Mixins(UserRoleMixin, GlobalAlertMixin) {
    public order = null;
    public open = false;
    public formValid = false;
    public cancelDetails = '';
    public cancelReason = 'Other';
    public cancelReasons = [
        'I made a mistake in my bookings (Wrong date, time or service)',
        'I will no longer be needing these services',
        'Other',
    ];

    @Watch('open')
    public onOpenChanged(value: boolean, oldValue: boolean) {
        if (!value) {
            this.cancelDetails = '';
            this.cancelReason = '';
        }
    }

    public openWith(order: any) {
        this.order = order;
        this.open = true;
    }
    public async tryCancel() {
        this.order.status = ORDER_STATUS.CANCELLING;
        this.order.customerCancelReason = this.cancelReason;
        this.order.customerCancelDetails = this.cancelDetails;
        try {
            await this.order.save();
            this.showAlert('Your request for cancellation has been submitted', 'success');
        } catch (e) {
            this.showAlert(e);
        }
    }
}
